
import { Component, Vue, Watch, Prop, } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class JustificationDialogComponent extends Vue {
  @Prop({ required: true, }) readonly showDialog!: boolean
  private justification = ''

  private dialog = false

  @Watch('showDialog')
  show (val: boolean): void {
    if (val) {
      this.dialog = true
    }
  }

  @Watch('dialog')
  dialogClose (): void {
    if (this.dialog === false) {
      this.$emit('close')
    }
  }

  private sendJustification () {
    this.dialog = false
    this.$emit('action', this.justification)
  }
}
